import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Card, Flex, Space, Typography,Spin } from 'antd';
import { toast } from 'react-toastify';
import EZUIKit from 'ezuikit-js';

const { Text } = Typography;

const LiveViewer = () => {
    const liveAddr = useSelector(state => state.Vehicles.liveAddr || {});
    const [player, setPlayer] = useState(null);
    const [pause, setPause] = useState(false);
    const [startTalk, setStartTalk] = useState(false);
    const [openSounds, setOpenSounds] = useState(false);
    const [record, setRecord] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!liveAddr || typeof liveAddr !== 'object') {
            return;
        }
        setIsLoading(true);
        if (!liveAddr.accessToken || !liveAddr.url) {
            setIsLoading(false);
            return;
        }

        const options = {
            id: 'video-live',
            accessToken: liveAddr.accessToken,
            url: liveAddr.url,
            template: 'simple',
            plugin: ['talk'], // 加载插件，talk-对讲
            // width: 600,
            // height: 400,
            handleError(err) {
                if (err.type === 'handleRunTimeInfoError' && err.data.nErrorCode === 5) {
                    // 加密设备密码错误
                }
                console.warn('EZUIKitPlayer handleError', err);
            }
        };
        // simple - 极简版; pcLive - pc 直播；pcRec - pc 回放；mobileLive - 移动端直播；mobileRec - 移动端回放; security - 安防版; voice - 语音版;
        options['template'] = 'standard';
        try {
            const ezPlayer = new EZUIKit.EZUIKitPlayer(options);
            console.log('ezPlayer', ezPlayer);
            setPlayer(ezPlayer);
        } catch (error) {
            console.error('初始化播放器失败', error);
        }
        setIsLoading(false);
    }, [liveAddr]);

    /**
     * @returns false: player 为空; true: player 不为空
     */
    function toastWhenPlayerIsNil() {
        if (!player) {
            toast.error(`播放器尚未初始化.`, { autoClose: 3000 });
            return false;
        }
        return true;
    }
    async function play() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            setPause(false);
            const rst = await player.play();
            console.log('play 数据', rst);
        } catch (err) {
            console.error('play failed', err);
        }
    }
    async function stop() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            setPause(true);
            const rst = await player.stop();
            console.log('stop 数据', rst);
        } catch (err) {
            console.error('stop failed', err);
        }
    }
    async function getOSDTime() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            const rst = await player.getOSDTime();
            console.log('getOSDTime 数据', rst);
        } catch (err) {
            console.error('getOSDTime failed', err);
        }
    }
    async function capturePicture() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            const rst = await player.capturePicture(`${new Date().getTime()}`);
            console.log('capturePicture 数据', rst);
        } catch (err) {
            console.error('capturePicture failed', err);
        }
    }
    async function openSound() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            setOpenSounds(true);
            const rst = await player.openSound();
            console.log('openSound 数据', rst);
        } catch (err) {
            console.error('openSound failed', err);
        }
    }
    async function closeSound() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            setOpenSounds(false);
            const rst = await player.closeSound();
            console.log('closeSound 数据', rst);
        } catch (err) {
            console.error('closeSound failed', err);
        }
    }
    async function startSave() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            setRecord(true);
            const rst = await player.startSave(`${new Date().getTime()}`);
            console.log('startSave 数据', rst);
        } catch (err) {
            console.error('startSave failed', err);
        }
    }
    async function stopSave() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            setRecord(false);
            const rst = await player.stopSave();
            console.log('stopSave 数据', rst);
        } catch (err) {
            console.error('stopSave failed', err);
        }
    }
    async function ezopenStartTalk() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            setStartTalk(true);
            const rst = await player.startTalk();
            console.log('startTalk 数据', rst);
        } catch (err) {
            console.error('startTalk failed', err);
        }
    }
    async function ezopenStopTalk() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            setStartTalk(false);
            const rst = await player.stopTalk();
            console.log('stopTalk 数据', rst);
        } catch (err) {
            console.error('stopTalk failed', err);
        }
    }
    async function fullScreen() {
        if (!toastWhenPlayerIsNil()) {
            return;
        }

        try {
            const rst = await player.fullScreen();
            console.log('fullScreen 数据', rst);
        } catch (err) {
            console.error('fullScreen failed', err);
        }
    }

    const renderVideoContent = () => {
        if (isLoading || !liveAddr.accessToken || !liveAddr.url) {
            return (
                <div style={{
                    width: '100%', 
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#000000b3'
                }}>
                    <Spin size="large" />
                </div>
            );
        }

        return <div id="video-live" style={{ width: '100%', height: '100%' }}></div>;
    };

    return (
        <div className="video-container" style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#000' }}>
            {renderVideoContent()}
        </div>
        <div style={{ padding: '8px', backgroundColor: '#1a1a1a', display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center', justifyContent: 'center' }}>
            <Button size="small" type={pause ? "primary" : "default"} disabled={!player} onClick={stop}>
                暂停
            </Button>
            <Button size="small" disabled={!player} onClick={play}>
                播放
            </Button>
            <Button size="small" type={openSounds ? "primary" : "default"} disabled={!player} onClick={openSound}>
                开声
            </Button>
            <Button size="small" disabled={!player} onClick={closeSound}>
                关声
            </Button>
            <Button size="small" type={record ? "primary" : "default"} disabled={!player} onClick={startSave}>
                录制
            </Button>
            <Button size="small" disabled={!player} onClick={stopSave}>
                停止
            </Button>
            <Button size="small" disabled={!player} onClick={capturePicture}>
                截图
            </Button>
            <Button size="small" disabled={!player} onClick={fullScreen}>
                全屏
            </Button>
            <Button size="small" type={startTalk ? "primary" : "default"} disabled={!player} onClick={ezopenStartTalk}>
                对讲
            </Button>
            <Button size="small" disabled={!player} onClick={ezopenStopTalk}>
                结束
            </Button>
        </div>
    </div>
    );
};

export default LiveViewer;
